import { useContext } from 'react';
import { AxiosContext } from '../context/AuthContext';

export function useAxios() {
  return useContext(AxiosContext);
}
